import actionTypes from 'SRC/modules/redux/actionTypes'

export const setRegionsByCountry = (country, regions) => {
  return {
    type: actionTypes.SET_REGIONS_BY_COUNTRY,
    payload: {country, regions}
  }
}
